module.exports = __webpack_public_path__ + "img/banner1.550dc6ea.jpg";